import { MeViewedHintsCertificate } from '@yandex-int/k-common/typings';

import * as constants from './constants';
import { CertificateModalActions } from './typings';

const STAT_BY_ACTION_TYPE = {
    [constants.ACCEPT_SUGGESTION_SUCCESS]: 'last_agree',
    [constants.CANCEL_SUGGESTION]: 'last_cancel',
    [constants.CLOSE_SUGGESTION]: 'last_close',
};

export function updateCertificateStats(stats: MeViewedHintsCertificate | null, actionType: CertificateModalActions) {
    const newStats = normalizeCertificateStats(stats);

    newStats.closes_count += 1;

    if (actionType.type in STAT_BY_ACTION_TYPE) {
        // @ts-ignore
        newStats[STAT_BY_ACTION_TYPE[actionType.type]] = new Date().toISOString();
    }

    return newStats;
}

function normalizeCertificateStats(stats: MeViewedHintsCertificate | null) {
    return {
        closes_count: normalizeCount(stats?.closes_count),
        last_close: normalizeDate(stats?.last_close),
        last_cancel: normalizeDate(stats?.last_cancel),
        last_agree: normalizeDate(stats?.last_agree),
    };
}

function normalizeCount(num?: number) {
    const newNum = Number(num);

    return isNaN(newNum) ? 0 : newNum;
}

function normalizeDate(date?: string) {
    if (!date) {
        return null;
    }
    const newDate = Date.parse(date);

    return isNaN(newDate) ? null : new Date(newDate).toISOString();
}

function normalizeFullName(fullName?: string) {
    return fullName?.trim().replace(/\s+/g, ' ');
}

export function splitFullName(fullName?: string) {
    const splittedName = normalizeFullName(fullName)?.split(' ');

    if (!splittedName) {
        return {};
    }

    let firstName;
    let middleName;
    let lastName = splittedName.shift();

    // Формат с девичьей фамилией: Иванова (Петрова) Анна Сергеевна
    if (/^\([^()]+\)$/.test(splittedName[0])) {
        const maidenName = splittedName.shift();

        lastName = `${lastName} ${maidenName}`;
    }

    if (splittedName.length > 1) {
        middleName = splittedName.pop();
    }

    if (splittedName.length > 0) {
        firstName = splittedName.join(' ');
    }

    return {
        full_name: fullName, // сохраняем в нижнем регистре для консистентности и помощи в решении возможных проблем
        last_name: lastName,
        first_name: firstName,
        middle_name: middleName,
    };
}
